import { CryptoCurrencies } from "../enums/cryptoCurrency.js";
import { Networks } from "../enums/networks.js";

export const returnNetwork = (network,cryptoCurrency) => {
    switch (network) {
        case Networks.TRON:
            if(cryptoCurrency === CryptoCurrencies.USDT){
                return Networks.TRON + "(TRC20)";
            }else{
                return Networks.TRON;
            }				
        case Networks.BITCOIN:
            return Networks.BITCOIN;
        case Networks.ETHEREUM:
            if(cryptoCurrency === CryptoCurrencies.USDT || cryptoCurrency === CryptoCurrencies.USDC){
                return Networks.ETHEREUM + "(ERC20)";
            }else{
                return Networks.ETHEREUM;
            }
        case Networks.BASE:
            if(cryptoCurrency === CryptoCurrencies.USDC){
                return Networks.BASE + "(ERC20)";
            }else{
                return Networks.BASE;
            }
        case Networks.LITECOIN:
            return Networks.LITECOIN;
        case Networks.DOGECOIN:
            return Networks.DOGECOIN;
        case Networks.RIPPLE:
            return Networks.RIPPLE;			
        default:
            return "";
    }
}